import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import {
    ExportRequest,
    ImportReport,
    ImportRequest,
    TransferManifest,
    TransferTypeInfo
} from './transfer.model';

/**
 * Hand-written wrapper around dmp-configurator's TransferResource (/api/transfers/*).
 * Not generated by @tj/tj-dmp-lib-api: that client predates this backend endpoint. Unlike the
 * usual generated services, every call here takes the tenant explicitly (never implicit via
 * ProfileService) since export and import naturally involve two different tenants (source/target).
 */
@Injectable({ providedIn: 'root' })
export class TransferService {
    private resourceUrl = environment.SERVER_API_URL + 'services/configurator/api/transfers';

    constructor(private http: HttpClient) {}

    private headers(datastore: string): HttpHeaders {
        return new HttpHeaders().set('X-DataStoreID', datastore);
    }

    listTypes(datastore: string): Observable<TransferTypeInfo[]> {
        return this.http.get<TransferTypeInfo[]>(`${this.resourceUrl}/types`, { headers: this.headers(datastore) });
    }

    exportObjects(sourceTenant: string, request: ExportRequest): Observable<TransferManifest> {
        return this.http.post<TransferManifest>(`${this.resourceUrl}/export`, request, {
            headers: this.headers(sourceTenant)
        });
    }

    importManifest(targetTenant: string, request: ImportRequest): Observable<ImportReport> {
        return this.http.post<ImportReport>(`${this.resourceUrl}/import`, request, {
            headers: this.headers(targetTenant)
        });
    }

    duplicateBrevoTemplate(
        targetTenant: string,
        sourceTenant: string,
        templateId: number
    ): Observable<{ templateId: number }> {
        return this.http.post<{ templateId: number }>(
            `${this.resourceUrl}/brevo-templates/duplicate`,
            { sourceTenant, templateId },
            { headers: this.headers(targetTenant) }
        );
    }
}
